import { render, staticRenderFns } from "./DialogSingleDayType.vue?vue&type=template&id=2b226b2a&scoped=true"
import script from "./DialogSingleDayType.vue?vue&type=script&lang=js"
export * from "./DialogSingleDayType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b226b2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b226b2a')) {
      api.createRecord('2b226b2a', component.options)
    } else {
      api.reload('2b226b2a', component.options)
    }
    module.hot.accept("./DialogSingleDayType.vue?vue&type=template&id=2b226b2a&scoped=true", function () {
      api.rerender('2b226b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/dialogs/dialog_single_day_type/DialogSingleDayType.vue"
export default component.exports